import { registerFlow } from '../../../../core/flow-register';
import { makeFlow } from '..';
import { IRAAccountTypes } from '../../../transfer-flows/loaders';

registerFlow(makeFlow('roth', IRAAccountTypes.ROTH));
